@let intrinsicValue = intrinsicValueSg();
@let enumTypedValue = enumTypedValueSg();
@let structureTypedValue = structureTypedValueSg();
<!-- NOTE: This is only needed for fallback purposes -->
@let value = valueSg();
@let valueInfo = valueInfoSg();

<!-- NOTE: using explicit 'undefined' checks to handle falsy values (0, '',
false) correctly. -->
@if (intrinsicValue !== undefined) {
  <atn-intrinsic-switcher
    [value]="intrinsicValue"
    [valueInfo]="valueInfo"
  />
} @else if (enumTypedValue !== undefined) {
  <atn-enum-switcher
    [value]="enumTypedValue.value"
    [enum]="enumTypedValue.type"
  />
} @else if (structureTypedValue !== undefined) {
  <atn-structure-switcher
    [value]="structureTypedValue.value"
    [structure]="structureTypedValue.type"
  />
} @else if (value) {
  <!-- Default to standard value display if no special handling applies -->
  <atn-standard-content [value]="value" />
}
